"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.propsObjectKeys = void 0;
/** Keys allowed for props filtering. Add here when extending PropsObject. */
exports.propsObjectKeys = ['projectId', 'taskIds'];
//# sourceMappingURL=Index.js.map